<template>
    <div id="page-top" class="row bg-dark-blue ml-0 mr-0" style="min-height: 94%; position: absolute; left: 0; right: 0;">
        <div class="apply-admission">
            <div class="card bs-turq">
                <div class="apply-admission-inner">
                    <h2 class="title text-center mt-3">
                        <span>Lets get started</span>
                    </h2>
                    <div>
                        <div class="apply-sent apply-sent-style1 mb-3" style="padding-top:20px">
                            <div class="form-sent-main text-center">
                                <label>Email</label>
                                <input :class="{ 'not-valid': v_email }" v-model="email" type="text" placeholder="Enter email address...">
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1">
                            <div class="form-sent-main text-center">
                                <label>Password</label>
                                <input :class="{ 'not-valid' : v_password }" v-model="password" type="password" placeholder="Enter password ...">
                            </div>
                            <div style="text-align: center; margin-top: 25px">
                                <button v-on:click="login" class="btn-cms-turq text-uppercase" href="#loader-modal" data-toggle="modal">Log In</button>
                            </div>
                        </div>
                        <br />
                        <div v-if="v_summary" class="alert alert-danger" style="text-align: center;">
                            {{ v_summary }}
                        </div>
                        <div class="caption text-center">
                            <div class="d-flex flex-column text-center">
                                Forgot your details?
                                <router-link class="register-link text-dark" to="/auth/forgot">Reset now</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

    .bs-turq {
        box-shadow: #42c1c4 0 0 20px 1px;
    }

    .apply-admission {
        margin: 0 auto;
        margin-top: 80px;
        position: relative;
        width: 50%;
        z-index: 100;
        margin-bottom: 20px;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'Login',
        components: {
        },
        data: function () {
            return {
                email: "",
                password: "",
                v_email: false,
                v_password: false,
                v_summary: ""
            }
        },
        methods: {
            validate: function () {
                this.v_email = false;
                this.v_password = false;
                this.v_summary = null;

                if (!this.isValidEmail(this.email)) {
                    this.v_summary = "Please enter a valid email address";
                    this.v_email = true;
                    return false;
                }

                if (!this.isNotEmpty(this.password)) {
                    this.v_summary = "Please enter a valid password with at least 6 characters";
                    this.v_password = true;
                    return false;
                }

                return true;
            },
            async login() {
                try {
                    if (this.validate()) {
                        var title = document.title;
                        var userState = await this.web('/auth/login', "Logging in", {
                            email: this.email,
                            password: this.password,
                            siteTitle: title
                        }, [400]);

                        //setting current user properties will log user in
                        this.$store.commit("setUserState", userState);
                    }
                }
                catch (e) {
                    console.error(e);
                    if (e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            }
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
        }
    };
</script>
